<template>
    <div v-if="schoolingChoice">
        <transition name="component-fade" mode="out-in">
            <div class="card">
                <header class="card-header">
                    <span class="card-header-title title is-5 has-text-weight-light">{{ $t('shop.cart.registrations') }}</span>
                </header>

                <div class="card-content">
                    <div v-if="candidate.applications.accepted && !candidate.applications.registration_complete && schoolingChoice">
                        <header class="card-header has-background-primary">
                            <span class="card-header-title title is-5 has-text-weight-light has-text-light">{{ $t('shop.cart.schooling') }}</span>
                        </header>
                        <div class="box p-sm" v-if="schooling">
                            {{ schooling.training_name }} section {{ schooling.training_option_name }}
                            <br>
                            <i>{{ schooling.campus_name }} - {{ schooling.scholar_year }}</i>

                            <div class="has-text-right">
                            <span>
                                <strong><i>{{ scholarFees() }}</i></strong>
                            </span>

                            </div>
                            <div class="has-text-centered">
                                <button class="button is-success m-t-sm" @click="restoreChoice({candidate:candidate, choice:schoolingChoice, school:school})">
                                    {{ $t('shop.offers.register') }}
                                </button>
                            </div>

                            <div class="p-t-md" v-if="schoolingChoices && schoolingChoices.length">

                                <h5 class="has-text-weight-light has-background-primary p-sm">
                                    <strong class="has-text-light"><i>{{ $t('shop.cart.offers') }}</i></strong>
                                </h5>
                                <div class="p-l-sm">
                                    <transition-group name="slide-fade">

                                        <div class="box p-sm" v-for="choice in schoolingChoices" :key="choice.id">
                                            <div>
                                                <span class="is-size-6 has-text-weight-bold" v-if="choice">{{ choice.offer.name.fr }}</span>
                                            </div>
                                            <div v-if="choice.session">
                                                <div class="is-size-7" v-if="choice">{{ choice.session.campus.name }}</div>
                                                <div class="is-size-7" v-if="choice"><i>{{ choice.session.begin | moment }}</i> au <i>{{ choice.session.end | moment }}</i></div>
                                            </div>
                                            <div class="columns">
                                                <div class="column">
                                                    <!--<a @click="removeChoiceFromCart({candidate, choice})">
                                                        supprimer
                                                    </a>-->
                                                </div>
                                                <div class="column is-4 has-text-right">
                                            <span v-if="!choice.session">
                                                <strong><i>{{ offerFees(choice.offer.prices) }}</i></strong>
                                            </span>
                                                    <span v-else>
                                                <strong><i>{{ offerFees(choice.session.prices) }}</i></strong>
                                            </span>
                                                </div>
                                            </div>
                                        </div>
                                    </transition-group>
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr v-show="offerChoices && schoolingChoice">

                    <!--<div class="p-t-md" v-if="offerChoices">

                        <transition-group name="slide-fade">
                            <div class="box p-sm" v-for="choice in offerChoices" :key="choice.id">
                                <div>
                                    <span class="is-size-6 has-text-weight-bold" v-if="choice">{{ choice.offer.name.fr }}</span>
                                </div>
                                <div v-if="choice.session">
                                    <div class="is-size-7" v-if="choice">{{ choice.session.campus.name }}</div>
                                    <div class="is-size-7" v-if="choice"><i>{{ choice.session.begin | moment }}</i> au <i>{{ choice.session.end | moment }}</i></div>
                                </div>
                                <div class="columns">
                                    <div class="column">
                                        <a @click="removeChoiceFromCart({candidate, choice})">
                                            {{ $t('labels.general.delete') }}
                                        </a>
                                    </div>
                                    <div class="column is-4 has-text-right">
                                        <span v-if="!choice.session">
                                            <strong><i>{{ offerFees(choice.offer.prices) }}</i></strong>
                                        </span>
                                        <span v-else>
                                            <strong><i>{{ offerFees(choice.session.prices) }}</i></strong>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </transition-group>
                    </div>-->
                </div>
            </div>
        </transition>
    </div>
</template>

<script>

    import {mapActions, mapGetters} from 'vuex'

    export default {
        data () {
            return {}
        },
        props: {
            candidate: { type: Object },
            status: { type: String }
        },
        computed: {
            ...mapGetters(
                'auth', [
                    'getAccount'
                ]
            ),
            ...mapGetters(
                'orders', [
                    'candidateChoicesByCategory',
                    'candidateSchooling',
                    'candidateSchoolingDetails',
                    'candidateSchoolingChoices',
                    'candidateOfferChoices',
                    'checkoutStatus'
                ]
            ),
            ...mapGetters(
                'organization', [
                    'getSchoolBySlug'
                ]
            ),
            schoolingChoice() {
                return this.candidateSchooling(this.candidate, this.status)
            },
            schoolingChoices() {
                return this.candidateSchoolingChoices(this.candidate, this.status)
            },
            offerChoices() {
                return this.candidateOfferChoices(this.candidate, this.status)
            },
            school() {
              return this.getSchoolBySlug(this.$route.params.school)
            },
            schooling() {
                return this.candidateSchoolingDetails(this.candidate, this.status)
            }

        },
        methods: {
            ...mapActions(
                'orders', [
                    'removeChoiceFromCart',
                    'restoreChoice'
                ]
            ),
            scholarFees () {
                const school = this.getSchoolBySlug(this.$route.params.school)

                if (this.candidateSchooling(this.candidate, this.status).type === 'boardingschool') {

                    if (this.candidateSchooling(this.candidate, this.status).internship === 1) {
                        return this.candidateSchooling(this.candidate, this.status).fees.internship_fees +' '+ school.fees_currency
                    } else {
                        return this.candidateSchooling(this.candidate, this.status).fees.externship_fees +' '+ school.fees_currency
                    }

                }
            },
            offerFees (prices) {
                const school = this.getSchoolBySlug(this.$route.params.school)
                return prices.filter(function (price) {
                    return price.school_id === school.id
                }).map(price => price.price+' '+price.currency)[0];
            }
        },
        filters: {
            moment: function (date) {
                return moment(date).format('LL')
            }
        }
    }
</script>

<style scoped>

</style>
